import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const scrollToContact = () => {
  const el = document.getElementById("contact");
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export default function CtaBanner() {
  return (
    <section
      data-testid="mid-cta-banner"
      className="relative py-16 lg:py-24 border-t border-white/10 overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute inset-0 opacity-40 pointer-events-none"
        style={{
          background:
            "radial-gradient(1200px circle at 20% 50%, rgba(226,255,49,0.08), transparent 45%), radial-gradient(1000px circle at 80% 50%, rgba(59,130,246,0.05), transparent 40%)",
        }}
      />
      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="lg:col-span-8"
        >
          <div className="font-mono-tag text-[10px] text-[#E2FF31] mb-4">
            // Your project could be next
          </div>
          <h3 className="font-display font-medium text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
            Like what you see?{" "}
            <span className="text-white/40">Let&apos;s build yours next.</span>
          </h3>
          <p className="mt-5 text-white/60 text-base max-w-xl">
            Fixed quote, weekly demos and a launch-ready site in under two
            weeks. Reply within one business day, guaranteed.
          </p>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="lg:col-span-4 flex flex-col gap-3 lg:justify-self-end"
        >
          <button
            data-testid="mid-cta-book"
            data-cursor="Book"
            onClick={scrollToContact}
            className="btn-primary justify-center"
          >
            Book a free intro call
            <ArrowUpRight size={16} />
          </button>
          <a
            href="https://wa.me/971565674843"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="mid-cta-whatsapp"
            className="btn-ghost justify-center"
          >
            WhatsApp me now
            <ArrowUpRight size={14} />
          </a>
        </motion.div>
      </div>
    </section>
  );
}
